import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout';
import Shop from './pages/Shop/shop';
import Tailor from './pages/Tailor/tailor';
import TailorProfiles from './pages/Tailor/components/tailors/tailors';
import TailorServices from './pages/Tailor/components/services/services';
import Design from './pages/Design/design';
import Opportunities from './pages/Opportunities/opportunities';
import Apply from './pages/Opportunities/apply/apply';
import { CartProvider } from './components/CartContext';
import Cart from './pages/Cart/Cart';
import Checkout from './components/Checkout/Checkout';
import CookiePolicy from './components/terms/cookiespolicy';
import PrivacyPolicy from './components/terms/privacypolicy';
import TermsOfService from './components/terms/termsofservice';

function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Shop />} />
            <Route path="shop" element={<Shop />} />
            <Route path="tailor" element={<Tailor />} />
            <Route path="tailorprofiles" element={<TailorProfiles />} />
            <Route path="tailorservices" element={<TailorServices />} />
            <Route path="design" element={<Design />} />
            <Route path="cart" element={<Cart />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="opportunities" element={<Opportunities />} />
            <Route path="apply" element={<Apply />} />
            <Route path="cookies" element={<CookiePolicy />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="terms" element={<TermsOfService />} />
          </Route>
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;